import React from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'

type RenderIndicatorFn = (
  clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
  isSelected: boolean,
  index: number,
  label: string,
) => React.ReactNode

/* Need to use custom control dots because of following accessibility error:
    Bad value button for attribute role on element li. (42)
    Attribute value not allowed on element li at this point. (42) */
const renderIndicator: RenderIndicatorFn = (
  clickHandler,
  isSelected,
  index,
  label,
) => {
  const className = `dot ${isSelected ? 'selected' : ''}`
  return (
    <li
      aria-controls={`carousel-panel-${index}`}
      aria-label={label}
      className={className}
      data-index={index}
      onClick={clickHandler}
      onKeyDown={clickHandler}
      role="presentation"
    ></li>
  )
}

const renderThumbs = (children: React.ReactChild[]) => {
  return children
}

const ArtboxoneCarousel = (options: any) => {
  return (
    <Carousel
      preventMovementUntilSwipeScrollTolerance={true}
      renderIndicator={renderIndicator}
      renderThumbs={renderThumbs}
      showArrows={true}
      showStatus={false}
      showThumbs={options.showThumbs}
      thumbWidth={64}
      useKeyboardArrows={true}
    >
      {options.children}
    </Carousel>
  )
}

export default ArtboxoneCarousel
